@if (mode() === 'view') {
  <mat-chip
    class="ms-0 advanced-filter-chip"
    [style]="{ height: '48px' }"
    [class]="filter().isInvalid?.() ? 'red' : ''"
    [removable]="true"
    (removed)="removeClick.emit()"
    (mouseover)="
      hoveredFilterIdentityUpdate.emit({
        field: filter().field,
        operator: filter().operator,
        idOfCustom: filter().idOfCustom,
      })
    "
    (mouseleave)="hoveredFilterIdentityUpdate.emit(null)"
    (click)="mode.set('edit')"
  >
    @if (filter().field === 'date') {
      <div class="d-flex align-items-center date-chip-content">
        <button
          type="button"
          class="date-chip-icon-button"
          [matTooltip]="'general.previousPeriod' | translate"
          [attr.aria-label]="'general.previousPeriod' | translate"
          (click)="$event.stopPropagation(); adjustDate(-1)"
        >
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="date-chip-label">{{ label() }}</span>
        <button
          type="button"
          class="date-chip-icon-button date-chip-remove-button"
          [attr.aria-label]="'button.remove' | translate"
          (click)="$event.stopPropagation(); removeClick.emit()"
        >
          <mat-icon>cancel</mat-icon>
        </button>
        <button
          type="button"
          class="date-chip-icon-button"
          [matTooltip]="'general.nextPeriod' | translate"
          [attr.aria-label]="'general.nextPeriod' | translate"
          (click)="$event.stopPropagation(); adjustDate(1)"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    } @else {
      <span>{{ label() }}</span>
    }
    <mat-icon matChipRemove>cancel</mat-icon>
  </mat-chip>
} @else {
  <div
    class="advanced-filter-inputs-chip px-2"
    (mouseover)="hoveredFilterIdentityUpdate.emit(selectedFilterIdentity)"
    (mouseleave)="hoveredFilterIdentityUpdate.emit(null)"
  >
    <advanced-filter-inputs
      [dataForWidgetSpecificConfiguration]="null"
      [inputsConfiguration]="{
        type: 'edit',
        mode: EAdvancedFilterInputMode.autoSubmitWithCancel,
        initialValues: dataForEdit(),
        isEqAllowed: false,
      }"
      [(selectedFilterIdentity)]="selectedFilterIdentity"
      (autoSubmit)="submitEdit($event)"
      (deleteClick)="removeClick.emit()"
      (dismissClick)="convertToChip()"
    ></advanced-filter-inputs>
  </div>
}
